import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Buttons } from '@app/entities/models/buttons/buttons';

import { MButtonComponent } from '@mercadona/components-musi/button';
import { MCardComponent } from '@mercadona/components-musi/card';
import { MClickDirective } from '@mercadona/components-musi/common';
import { MTranslatePipe } from '@mercadona/core/translate';

export type TwoFactorCardActionsPosition = 'between' | 'center' | 'end';

@Component({
  selector: 'app-ptrab-two-factor-card',
  imports: [MCardComponent, MButtonComponent, MClickDirective, MTranslatePipe],
  templateUrl: './two-factor-card.component.html',
  styleUrls: ['./two-factor-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PtrabTwoFactorCardComponent {
  readonly title = input.required<string>();
  readonly imageSrc = input.required<string>();
  readonly buttons = input<Buttons[]>([]);
  readonly actionsPosition = input<TwoFactorCardActionsPosition>('end');
}
